import React, { useRef } from 'react'
import Button from '../../../common-components/button'
import { handleDeviceDetection, device_type, state_action } from '../ActionHelper'
import _ from 'lodash'

const ImagePreview = ({ onNextPage, DataImage, typemodal }) => {
  const fileInputRef = useRef(null)
  const onCheckType = () => {
    try {
      const checkDevice = handleDeviceDetection()
      if (checkDevice == device_type.Mobile) {
        window.ktaxaocr.callcheck(
          'CAMERA',
          function(response) {
            window.ktaxaocr.opencamera(
              function(res) {
                onNextPage(state_action.previewimage, res)
              },
              function(res) {
                alert(res)
              }
            )
          },
          function(error) {
            alert(error)
          }
        )
      } else {
        onNextPage(state_action.opencamara_onweb, null)
      }
    } catch (error) {
      onNextPage(state_action.previewimage, null)
    }
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        // You can send the file content to the next page or process it as needed
        onNextPage(state_action.previewimage, _.replace(e.target.result, 'data:image/jpeg;base64,', ''))
      }
      reader.readAsDataURL(file)
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: window.innerWidth * 0.93,
          height: window.innerHeight * 0.7,
          backgroundColor: '#333',
        }}
      >
        <img
          src={`data:image/jpeg;base64,${DataImage}`}
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </div>
      <div
        style={{
          width: window.innerWidth * 0.93,
          height: window.innerHeight * 0.15,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: '50%',
            header: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            style={{
              width: '90%',
            }}
            outline={false}
            onClick={() => {
              if (typemodal == 'CAMARA') {
                onCheckType()
              } else {
                const checkDevice = handleDeviceDetection()
                if (checkDevice === device_type.Mobile) {
                  window.ktaxaocr.callcheck(
                    'PICKUPIMAGE',
                    function(response) {
                      window.ktaxaocr.pickerbookbank(
                        (base64Image) => {
                          onNextPage(state_action.previewimage, base64Image)
                        },
                        (error) => {
                          console.error('window.ktaxaocr.pickerbookbank error', error)
                        }
                      )
                    },
                    function(error) {
                      console.error('checkDevice error: ', error)
                    }
                  )
                } else {
                  fileInputRef.current.click()
                }
              }
            }}
            disabled={false}
          >
            แนบใหม่
          </Button>
        </div>
        <div
          style={{
            width: '50%',
            header: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            style={{
              width: '90%',
            }}
            outline={false}
            onClick={() => {
              onNextPage(state_action.loadingapi, null)
            }}
            disabled={false}
          >
            ยืนยัน
          </Button>
        </div>

        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
          accept="image/*"
          capture="filesystem"
        />
      </div>
    </>
  )
}

export default ImagePreview
